import { useCharacter } from "../character";
import { text } from "../text";

/** A computed value; tapping it opens its derivation. */
export function Value(props: { valueKey: string; label?: string; showLabel?: boolean; className?: string }) {
  const { value, display, showDerivation, language } = useCharacter();
  const computed = value(props.valueKey);
  if (!computed) return <span className="value missing">–</span>;
  const label = props.label ?? text(computed.label, language);
  const shown = display(computed);
  return (
    <button
      type="button"
      className={`value${props.className ? ` ${props.className}` : ""}`}
      onClick={() => showDerivation(props.valueKey)}
      aria-label={`${label}: ${shown}, Herleitung anzeigen`}
      data-value={props.valueKey}
    >
      {props.showLabel && <span className="value-label">{label}</span>}
      <span className="value-number">{shown}</span>
      {(computed.notes ?? []).length > 0 && <span className="value-note" aria-hidden="true">*</span>}
    </button>
  );
}

export function ValueRow(props: { valueKey: string; label?: string; hint?: string }) {
  const { value, language } = useCharacter();
  const computed = value(props.valueKey);
  return (
    <div className="value-row">
      <span className="value-row-label">
        {props.label ?? text(computed?.label, language)}
        {props.hint && <span className="muted"> {props.hint}</span>}
      </span>
      <Value valueKey={props.valueKey} label={props.label} />
    </div>
  );
}
